import { put, call, select, takeEvery } from "redux-saga/effects";

import * as apis from "../../../network/apis/companyPortalNotifications";
import {
  getCompanyNotificationsResponse,
  getCompanyDropdownNotificationsResponse,
  setCompanyUnseenNotificationsCount,
  replaceCompanyNotification,
} from "./actions";
import * as types from "./types";
import { showErrorMsg } from "../../../utils/Helpers";

function* getCompanyNotificationsSaga({ payload }) {
  try {
    const response = yield call(apis.getCompanyPortalNotifications, payload);
    yield put(
      getCompanyNotificationsResponse({
        list: response.data.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      }),
    );
  } catch (error) {
    if (error.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

// `background`: the navbar's ask on every page, with no loader and no error toast.
export function* getCompanyDropdownNotificationsSaga({ payload }) {
  const { background, ...params } = payload;
  try {
    const response = yield call(apis.getCompanyPortalNotifications, params, { background });
    yield put(getCompanyDropdownNotificationsResponse(response.data.data));
  } catch (error) {
    if (error.response && !background) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

// Opening the list leaves the badge: it stays while unread notifications remain (PROLINE-4169).
// Only unread ones are marked seen, so each one marked takes one off.
export function* setCompanyNotificationSeenSaga({ payload }) {
  try {
    const response = yield call(apis.setCompanyPortalNotificationSeen, payload);
    yield put(replaceCompanyNotification(response.data.data));
    const count = yield select(
      (state) => state.companyNotifications.unseenNotificationsCount,
    );
    yield put(setCompanyUnseenNotificationsCount(Math.max(0, (Number(count) || 0) - 1)));
  } catch (error) {
    if (error.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

export default function* CompanyNotificationsSagas() {
  yield takeEvery(
    types.GET_COMPANY_NOTIFICATIONS_REQUEST,
    getCompanyNotificationsSaga,
  );
  yield takeEvery(
    types.GET_COMPANY_DROPDOWN_NOTIFICATIONS_REQUEST,
    getCompanyDropdownNotificationsSaga,
  );
  yield takeEvery(
    types.SET_COMPANY_NOTIFICATION_SEEN,
    setCompanyNotificationSeenSaga,
  );
}
